import React from 'react';
import '../../../styles/mainContents.css'
import { fetchLoc } from '../../../redux/actions/PostActions';
import { useSelector, useDispatch, connect } from 'react-redux';
import ErrorHandler from '../zzzPracticeTestPages/ErrorHandler';
import { Link, Switch, useHistory } from 'react-router-dom';
import MUIDataTable from 'mui-datatables';
// import { Link } from 'react-router';
import BatteryHeader from './../../layout/BatteryHeader';

function Corporate(props) {

  const dispatch = useDispatch();
  const history = useHistory();

  const {authreducer, fetch_loc, locState, errorHandler, logoutJWT} = props;
  //console.log("Corporate() props: " + JSON.stringify(props));
  //console.log("Corporate() fetch_loc: " + JSON.stringify(fetch_loc() ));
  //console.log("Corporate() postState: " + JSON.stringify(postState));
  console.log("Corporate() authreducer: " + JSON.stringify(authreducer));
  //var test = JSON.stringify(fetch_loc());
  


  const columns = [
    {
      name: "LOC",
      label: "loc",
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      name: "NAME",
      label: "name",
      options: {
        filter: true,
        sort: true,
      },
    },
  ]

  const options = {
    filterType: "checkbox",
  };

  return (

    <div className="BatteryCN">
      {/* <Home /> */}

 
      <main>

        <div>
          <ErrorHandler errorHandler={errorHandler || {hasError: false, message: ''}} />

          <div>


            {console.log('Battery authreducer.isLoggedIn:', authreducer.isLoggedIn)}
            {!authreducer.isLoggedIn ? (

              <React.Fragment>              
                {history.push('/login')}
              </React.Fragment>
            ) : (
              <React.Fragment>
                <BatteryHeader pageTitle="- Corporate"/>
              </React.Fragment>
            )}

            <button
              onClick={ () => {
                //fetch_loc();
                dispatch(fetchLoc());
              }}
              > Fetch Loc Data
            </button>            

            <div>
            
              { locState.length > 0 ?
                  <MUIDataTable
                    title={"Loc Data"}
                    data={locState}
                    columns={columns}
                    options={options}
                  />
                : '' 
              }


            
            {  JSON.stringify(locState) }
            {/* <table id='test' className="tablesorter focus-highlight widget-zebra tablesorter-blue">
            <Headers/> 
              <thead>
                <tr>
                  <th>LOC</th>
                  <th>NAME</th>
                </tr>
              </thead> 
              <tbody>
                <tr>
                  <td>1</td>
                  <td>FMP</td>
                </tr>
              </tbody>
            </table> */}
            </div>



          </div>
        </div>

      </main>


    </div>

  );
}


const mapStateToProps = (state) => {
  //console.log("Corporate() mapStateToProps state: " + JSON.stringify(state));
  //console.log(state.posts['items_fetchLoc']);
  // console.log("Corporate() mapStateToProps state.authreducer: " + JSON.stringify(state.authreducer));

 return {
   locState: state.posts['items_fetchLoc'],
   authreducer: state.authreducer

 }

};

const mapDispatchToProps = (dispatch) => {
  console.log("Corporate() mapDispatchToProps called ");
  return {
    fetch_loc: () => {
      dispatch(fetchLoc());
    }//,
    // logoutJWT: () => {
    //   dispatch(LogoutJWTAuthAction());
    // }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Corporate);